import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'react';
import { Modal } from 'react-bootstrap';
import getPortalContainer from '../../util/get-portal-container.js';
import style from './terms-modal.style.js';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CloseIcon = function CloseIcon(props) {
  return jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: jsx("path", {
      d: "M10.939 12 7.47 15.47a.749.749 0 1 0 1.06 1.06L12 13.061l3.47 3.469a.749.749 0 1 0 1.06-1.06L13.061 12l3.469-3.47a.749.749 0 1 0-1.06-1.06L12 10.939 8.53 7.47a.749.749 0 1 0-1.06 1.06L10.939 12Z"
    })
  }));
};

CloseIcon.defaultProps = {
  viewBox: "0 0 24 24"
};

var renderContent = function renderContent(pack, onAction) {
  var _pack$packageOption$t;

  if (!pack) return null;
  return jsxs(Fragment, {
    children: [jsxs(Modal.Header, {
      children: [jsx("div", {
        css: style.close,
        onClick: function onClick() {
          return onAction('close-modal');
        },
        children: jsx(CloseIcon, {
          css: style.closeIcon
        })
      }), jsx("div", {
        children: pack.packageOption.termCondition
      })]
    }), jsx(Modal.Body, {
      children: jsx("div", {
        className: "ck-content",
        dangerouslySetInnerHTML: {
          __html: (_pack$packageOption$t = pack.packageOption.termConditionData) === null || _pack$packageOption$t === void 0 ? void 0 : _pack$packageOption$t.termConditionDetails
        }
      })
    })]
  });
};

var TermsModal = function TermsModal(_ref) {
  var pack = _ref.pack,
      show = _ref.show,
      onAction = _ref.onAction;
  var container = getPortalContainer();
  return jsx(Modal, {
    css: style.modal,
    centered: true,
    scrollable: true,
    size: "lg",
    show: show,
    container: container,
    children: renderContent(pack, onAction)
  });
};

export { TermsModal as default };